export const MAX_VISIBLE_MACHINES = 2;